module.exports = __webpack_public_path__ + "static/media/boat1-copyright.256e4a39.jpeg";